module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.$router.push('/cgd/by/user/edit/' + _vm.user.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("\n\t\t\t\t编辑\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "profile-image"
  }, [(_vm.user.avatar && _vm.user.avatar.url) ? _c('img', {
    staticClass: "img-circle circle-border m-b-md",
    attrs: {
      "alt": "image",
      "src": _vm.user.avatar.url
    }
  }) : _c('img', {
    staticClass: "img-circle circle-border m-b-md",
    attrs: {
      "alt": "image",
      "src": require("../../../common/assets/img/avatar.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "profile-info"
  }, [_c('div', {}, [_c('div', [_c('h2', {
    staticClass: "no-margins"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.user.nickname) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.user.role.name))]), _vm._v(" "), _c('div', {
    staticClass: "mb5"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.user.email) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "mb5"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.user.phone) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "mb5"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.user.description ? _vm.user.description : "这个人很懒，什么也没写") + "\n\t\t\t\t\t\t")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-00847494"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/user/Profile.vue
// module id = 941
// module chunks = 1